import { MeasurementResultsEvent, MeasurementResultsEventVars } from "./measurements/MeasurementResultsEvent";
import * as trackingEvents from "@goodgamestudios/tracking-event-types";

export class InGamePerformanceEvent extends MeasurementResultsEvent {
    public minFps: number;
    public maxFps: number;
    public fps: number;
    public inGameState: string;
    public animations: string;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): trackingEvents.InGamePerformance.Event {
        const parentVars: MeasurementResultsEventVars = super.getVars();

        const vars: trackingEvents.InGamePerformance.Event = {
            animations: this.animations,
            eventId: trackingEvents.InGamePerformance.ID,
            fps: this.fps,
            inGameState: this.inGameState,
            maxFps: this.maxFps,
            minFps: this.minFps,

            // copied from parent
            buildVersion: parentVars.buildVersion,
            connectionType: parentVars.connectionType,
            deviceId: parentVars.deviceId,
            level: parentVars.level,
            measurementDuration: parentVars.measurementDuration,
            memoryUsage: parentVars.memoryUsage,
            playerId: parentVars.playerId,
            sessionId: parseInt(parentVars.sessionId, 10),
            sessionTime: parentVars.sessionTime,
            storeId: parentVars.storeId,
        };

        return vars;
    }
}
